var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/images/icon-favourite-outline.png": "dced",
	"./assets/images/icon-play-invert.png": "992d",
	"./assets/images/logo-fg-image.png": "abbf",
	"./assets/images/logo-fg-text.png": "8892",
	"./assets/images/logo-phsargames-image.png": "1324",
	"./assets/images/logo-phsargames-text.png": "2b6f",
	"./assets/images/placeholder-thumbnail-profile-user.png": "824d",
	"./assets/images/thumbnail-404-outline.png": "30be",
	"./assets/images/thumbnail-game_on.png": "efd7",
	"./assets/styles/_base.scss": "9c1b",
	"./assets/styles/_extend.scss": "ef50",
	"./assets/styles/_reset.scss": "ab37",
	"./assets/styles/_typography.scss": "39d6",
	"./assets/styles/_util.scss": "51c0",
	"./assets/styles/_variables.scss": "6abf",
	"./assets/styles/app.scss": "a899",
	"./assets/styles/global.scss": "c860",
	"./assets/translations/en-my": "7cd1",
	"./assets/translations/en-my.json": "7cd1",
	"./assets/translations/id-id": "3a4b",
	"./assets/translations/id-id.json": "3a4b",
	"./assets/translations/km-kh": "350f",
	"./assets/translations/km-kh.json": "350f",
	"./components/component-games-list-featured": "f06d",
	"./components/component-games-list-featured.vue": "f06d",
	"./components/component-games-list-grid": "682c",
	"./components/component-games-list-grid.vue": "682c",
	"./components/component-games-list-history": "520d",
	"./components/component-games-list-history.vue": "520d",
	"./components/component-games-list-slick": "c667",
	"./components/component-games-list-slick.vue": "c667",
	"./components/component-games-list-slider": "cc64",
	"./components/component-games-list-slider.vue": "cc64",
	"./components/modal-advice-of-charge": "e070",
	"./components/modal-advice-of-charge.vue": "e070",
	"./components/modal-forgot-password": "cc06",
	"./components/modal-forgot-password.vue": "cc06",
	"./components/modal-login": "75ed",
	"./components/modal-login.vue": "75ed",
	"./components/modal-manage-subscription": "6cac",
	"./components/modal-manage-subscription.vue": "6cac",
	"./components/modal-notice": "0e62",
	"./components/modal-notice.vue": "0e62",
	"./components/modal-profile-update-name": "fb0e",
	"./components/modal-profile-update-name.vue": "fb0e",
	"./components/modal-profile-update-password": "1f9b",
	"./components/modal-profile-update-password.vue": "1f9b",
	"./components/modal-subscribed": "13a2",
	"./components/modal-subscribed.vue": "13a2",
	"./components/the-fab-scroll-top": "fb5d",
	"./components/the-fab-scroll-top.vue": "fb5d",
	"./components/the-footer": "7dad",
	"./components/the-footer.vue": "7dad",
	"./components/the-header": "2c91",
	"./components/the-header.vue": "2c91",
	"./components/the-modal": "6f57",
	"./components/the-modal.vue": "6f57",
	"./components/the-sidebar": "b33e",
	"./components/the-sidebar.vue": "b33e",
	"./ga": "4570",
	"./ga.js": "4570",
	"./i18n": "9225",
	"./i18n.js": "9225",
	"./idb": "d54f",
	"./idb.js": "d54f",
	"./layouts/layout-blank": "ebb2",
	"./layouts/layout-blank.vue": "ebb2",
	"./layouts/layout-default": "eb1e",
	"./layouts/layout-default.vue": "eb1e",
	"./main": "56d7",
	"./main.js": "56d7",
	"./registerServiceWorker": "ddb8",
	"./registerServiceWorker.js": "ddb8",
	"./router": "41cb",
	"./router.js": "41cb",
	"./store": "c0d6",
	"./store.js": "c0d6",
	"./store/api": "c151",
	"./store/api.js": "c151",
	"./store/auth": "889e",
	"./store/auth.js": "889e",
	"./store/i18n": "73b9",
	"./store/i18n.js": "73b9",
	"./store/ui": "132f",
	"./store/ui.js": "132f",
	"./store/users": "9ef5",
	"./store/users.js": "9ef5",
	"./sw": "249e",
	"./sw.js": "249e",
	"./views/page-404": "7526",
	"./views/page-404.vue": "7526",
	"./views/page-account": "01f7",
	"./views/page-account.vue": "01f7",
	"./views/page-auth": "3fa1",
	"./views/page-auth.vue": "3fa1",
	"./views/page-faq": "54df",
	"./views/page-faq.vue": "54df",
	"./views/page-favourites": "2bae",
	"./views/page-favourites.vue": "2bae",
	"./views/page-game_profile": "fd05",
	"./views/page-game_profile.vue": "fd05",
	"./views/page-genre": "7bfa",
	"./views/page-genre.vue": "7bfa",
	"./views/page-history": "b38b",
	"./views/page-history.vue": "b38b",
	"./views/page-landing": "19fe",
	"./views/page-landing.vue": "19fe",
	"./views/page-play": "bacf",
	"./views/page-play.vue": "bacf",
	"./views/page-popular": "02f6",
	"./views/page-popular.vue": "02f6",
	"./views/page-privacy_policy": "80b6",
	"./views/page-privacy_policy.vue": "80b6",
	"./views/page-terms": "cced",
	"./views/page-terms.vue": "cced"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";